import { LinkableEntityType } from '@api';
import { LegacyAnchor } from '@common';

type TourAnchorPropsType = { tour: LinkableEntityType };

export const TourAnchor: React.FC<TourAnchorPropsType> = ({ tour }) => {
  return (
    <LegacyAnchor href={`/projects/touring/${tour.id}`}>
      {tour.name}
    </LegacyAnchor>
  );

  // TODO: Replace LegacyAnchor with Anchor when we have the new touring page

  // return (
  //   <Anchor key={tour.id} to={`/projects/touring/$id`} params={{ id: tour.id }}>
  //     {tour.name}
  //   </Anchor>
  // );
};
